export default {
  data() {
    return {
      filterquery: "all"
    };
  },
  methods: {
    updateQuery(q) {
      this.filterquery = q;
    }
  }
};
